import { cleanVariantGID, cleanProductGID } from '@/utils/cleanGIDs';
import { getUserData } from '../../lib/elevar/cart-events';

export default function elevarItemView(
  isBundleProduct,
  productData,
  bundleData,
  stateVariant
) {
  const queryParams = new URLSearchParams(window.location.search);

  async function fireEvent() {
    if (typeof window === 'undefined') return;
    // get the referrer from session storage
    const storedReferrer = sessionStorage.getItem('referringCollection');
    const bundleProducts = [];
    if (isBundleProduct == true) {
      let selectedSize = 'Queen';
      const matchingProducts = [];
      if (queryParams?.get('size')) {
        selectedSize = queryParams?.get('size');
      }
      bundleData.bundleProducts?.forEach((product) => {
        const matchingVariant = product?.shopifyProduct?.variants.find(
          (variant) =>
            variant?.selectedOptions?.find((option) => option?.name == 'Size')
              ?.value == selectedSize
        );

        if (matchingVariant) {
          matchingProducts.push({
            variant: matchingVariant,
            product: product.shopifyProduct
          });
        }
      });

      matchingProducts.forEach((offer) => {
        const { variant, product } = offer;
        // create product cleansed product object for Elevar
        const bundleProduct = {
          id: variant?.sku || '', // SKU
          name: product.title || '', // Product title
          brand: 'Leesa',
          category: product?.productType || '',
          variant: variant?.title || '',
          price: variant?.price?.amount || '0.0',
          list: storedReferrer || '', // The list the product was discovered from
          product_id: cleanProductGID(product.id),
          variant_id: cleanVariantGID(variant?.id),
          compare_at_price: variant?.compareAtPrice?.amount || '0.0',
          image: variant?.image?.url || ''
        };

        bundleProducts.push(bundleProduct);
      });

      const userdata = getUserData();

      if (window.ElevarDataLayer) {
        window.ElevarDataLayer.push({
          event: 'dl_view_item',
          user_properties: userdata,
          ecommerce: {
            currencyCode: 'USD',
            detail: {
              actionField: {
                list: location.pathname || null,
                action: 'detail'
              },
              products: bundleProducts
            }
          }
        });
      }
    }
    if (!isBundleProduct) {
      const { shopifyProduct } = productData;

      const selectedVariant =
        stateVariant ||
        shopifyProduct?.variants?.find((variant) =>
          variant?.selectedOptions?.find((option) => option?.value == 'Queen')
        ) ||
        shopifyProduct?.variants[0];

      if (selectedVariant) {
        // create product cleansed product object for Elevar
        const product = {
          id: selectedVariant?.sku || '', // SKU
          name: shopifyProduct?.title || '', // Product title
          brand: 'Leesa',
          category: shopifyProduct?.productType || '',
          variant:
            selectedVariant?.variantTitle || selectedVariant?.title || '',
          price:
            selectedVariant?.price?.amount || selectedVariant?.price || '0.0',
          list: storedReferrer || '', // The list the product was discovered from
          product_id: cleanProductGID(shopifyProduct?.id),
          variant_id: cleanVariantGID(selectedVariant?.id),
          compare_at_price:
            selectedVariant?.compareAtPrice?.amount ||
            selectedVariant?.compareAtPrice ||
            '0.0',
          image: selectedVariant?.image?.url || selectedVariant?.image || ''
        };

        const userdata = getUserData();
        if (window.ElevarDataLayer) {
          window.ElevarDataLayer.push({
            event: 'dl_view_item',
            user_properties: userdata,
            ecommerce: {
              currencyCode: 'USD',
              detail: {
                actionField: {
                  list: storedReferrer || '',
                  action: 'detail'
                },
                products: [product]
              }
            }
          });
        }
      }
    }
  }

  fireEvent();
}
